var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg20CheckCircleFill(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "20-check-circle-fill"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0002 1.19995C6.03552 1.19995 1.2002 6.03528 1.2002 12C1.2002 17.9646 6.03552 22.7999 12.0002 22.7999C17.9649 22.7999 22.8002 17.9646 22.8002 12C22.8002 6.03528 17.9649 1.19995 12.0002 1.19995ZM16.6124 9.25025C16.9163 8.85694 16.8438 8.29172 16.4505 7.98779C16.0572 7.68387 15.492 7.75633 15.188 8.14965L10.7476 13.8961L8.76916 11.6979C8.43665 11.3284 7.86759 11.2985 7.49813 11.631C7.12867 11.9635 7.09872 12.5326 7.43123 12.902L10.1312 15.902C10.3098 16.1004 10.5672 16.2093 10.8339 16.1993C11.1006 16.1893 11.3491 16.0615 11.5124 15.8503L16.6124 9.25025Z",
    fill: "#0EA374"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg20CheckCircleFill);
export default __webpack_public_path__ + "static/media/20-check-circle-fill.f204dca59069b9732ae0cc39996230f0.svg";
export { ForwardRef as ReactComponent };